
import React from 'react'
import ReactDOM from 'react-dom';

/**
 * Renders a component into the DOM element.
 *
 * @param {string} domId - element's ID where component will be rendered
 * @param {Component} component - component from library which will be rendered
 * @param {Object} props - all props passed to rendered component
 */
export default function renderComponent(domId, component, props) {
    const domContainer = document.querySelector('#' + domId);
    if (domContainer) {
        ReactDOM.render(
            React.createElement(component, props),
            domContainer
        );
    }
}
